function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Recently Viewed Products - localStorage Management
const RecentlyViewed = {
  STORAGE_KEY: "recentlyViewedProducts",
  MAX_ITEMS: 12,

  /**
   * Get all recently viewed product handles
   * @returns {Array<string>} Array of product handles
   */
  getAll() {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error("Error reading recently viewed products:", error);
      return [];
    }
  },

  /**
   * Save a product handle to recently viewed
   * @param {string} productHandle - The product handle to save
   */
  save(productHandle) {
    if (!productHandle) return;

    try {
      let products = this.getAll();

      // Remove if already exists (to move to front)
      products = products.filter((handle) => handle !== productHandle);

      // Add to beginning
      products.unshift(productHandle);

      // Keep only MAX_ITEMS
      if (products.length > this.MAX_ITEMS) {
        products = products.slice(0, this.MAX_ITEMS);
      }

      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      console.error("Error saving recently viewed product:", error);
    }
  },
};

// Disable right-click on images and videos
const disableRightClick = () => {
  const preventContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  document.addEventListener("contextmenu", (e) => {
    if (e.target.tagName === "IMG" || e.target.tagName === "VIDEO") {
      preventContextMenu(e);
    }
  });

  document.addEventListener("dragstart", (e) => {
    if (e.target.tagName === "IMG" || e.target.tagName === "VIDEO") {
      e.preventDefault();
      return false;
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", disableRightClick);
} else {
  disableRightClick();
}
